// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-freeTextArea":"jobSearchDetail-freeTextArea"};